angular.module('pphhApp')
.directive('rolDetail',function () {
    return {
        restrict: 'E',
        templateUrl: "/gdu/user/rolEdit-template",
        scope:{
            roles: "=roles",
			dhs: "=dhs",
            roleData: "=roleData",             
            onDelete:"&onDelete"
            
        },
        controller: ['$scope', "$mdDialog","UserService", function rolDetailController($scope,$mdDialog,userService) {

			$scope.resetDialog=resetDialog;			
			
			$scope.clearAdmonInfo=clearAdmonInfo;
			$scope.openAdmResponsableDialog = openAdmResponsableDialog;
			$scope.deleteAllAdmon = deleteAllAdmon;
			$scope.addAdmon = addAdmon;
			$scope.loadAdminScope = loadAdminScope;
			
			$scope.modAdmon = modAdmon;
			$scope.deleteAdmon = deleteAdmon;
			$scope.isAddAdmonActionDisable = isAddAdmonActionDisable;
			$scope.cancelAdmonCuencaEdition = cancelAdmonCuencaEdition;
			
			$scope.coordinadorDhChange = coordinadorDhChange;
			$scope.clearCoordinadordh = clearCoordinadordh;
			$scope.reloadCoordinadorDh =reloadCoordinadorDh;
			
			$scope.clearCcaaInfo=clearCcaaInfo;
			$scope.deleteCcaa = deleteCcaa;
			$scope.openCcaaDialog = openCcaaDialog;
			$scope.addCcaa = addCcaa;
			$scope.isCcaaAlreadyAdded = isCcaaAlreadyAdded;
			$scope.isAddCcaaActionDisable = isAddCcaaActionDisable;
					
			
			$scope.clearDhInfo=clearDhInfo;
			$scope.deleteDh = deleteDh;
			$scope.openDhDialog = openDhDialog;
			$scope.addDh = addDh;
			$scope.isDhAlreadyAdded = isDhAlreadyAdded;
			$scope.isAddDhActionDisable = isAddDhActionDisable; 
			$scope.validToChange = validToChange; 
			
			clearAdmonInfo();
			clearCoordinadordh();		
			$scope.clearDhInfo ();
			clearCcaaInfo();
			
			$scope.admonInEdition = null;
			
			function resetDialog() {
			    $scope.admonInfo = {};
			    $scope.clearAdmonInfo();
			    
			    $scope.clearCcaaInfo();
			    
			    $scope.clearDhInfo ();
				$scope.clearCoordinadordh();

			    $scope.roleData.administrations=[];
			    $scope.roleData.ccaas=[];
			    $scope.roleData.dhs=[];				
			    
			}

			//**************************
			//ADMINISTRACION_RESPONSABLE
			//**************************
			function clearAdmonInfo() {
				$scope.admonInfo = {};
			    $scope.admonInfo.adminId = null;
			    $scope.admonInfo.admResponsable = null;
			    $scope.admonInfo.validFrom = null;
			    $scope.admonInfo.validTo = null;
			    $scope.admonInfo.admScope = [];
				
			}      
			function openAdmResponsableDialog(roleName) {

				$mdDialog.show({
					clickOutsideToClose: true,
					controller: "openAdmResponsableDialogController",
					parent: angular.element(document.body),
					templateUrl: "/cc/adm-dialog/template",
					resolve: {
						roleName: function() {
							return roleName;
						}
					}
				})
				.then(
					function(selected) {
						
						$scope.admonInfo.adminId = selected.key;
						$scope.admonInfo.admResponsable = selected.value;

						if (roleName !== 'PPHH_AUTORIDAD_CUENC') {
							deleteAllAdmon();
							addAdmon($scope.admonInfo);
						} else {
							loadAdminScope($scope.admonInfo);
						}							
					}
				);
			}		
			function deleteAllAdmon() {
				if ($scope.roleData.administrations.length > 0) {
				    $scope.roleData.administrations.splice(0, $scope.roleData.administrations.length);
				}
			}			
			function addAdmon(admResponsable) {
				$scope.roleData.administrations.push(angular.copy(admResponsable));   
				$scope.clearAdmonInfo();  				
			}			
			function loadAdminScope(admResponsable) {

				userService.getAdmonScope(admResponsable.adminId)
					.then(
						function(response) {
							admResponsable.admScope = response.data;
							angular.forEach(admResponsable.admScope, function(scope) {
								scope.checked = true;
							});
						}
					);
									
			}		
			
			//**************************
			//AUTORIDAD_CUENCA
			//**************************
			function modAdmon(admonInfo) {
				$scope.admonInfo.adminId = admonInfo.adminId;
				$scope.admonInfo.admResponsable = admonInfo.admResponsable;

				if (admonInfo.validFrom == null) {
					$scope.admonInfo.validFrom = null;
				} else {
					$scope.admonInfo.validFrom = moment(admonInfo.validFrom).toDate();
				}

				if (admonInfo.validTo == null) {
					$scope.admonInfo.validTo = null;
				} else {
					$scope.admonInfo.validTo = moment(admonInfo.validTo).toDate();
				}
				if( ($scope.roleData.roleName === 'PPHH_AUTORIDAD_CUENC') && (admonInfo.admScope === undefined || admonInfo.admScope.length == 0)){
					loadAdminScope (admonInfo);
				}
				$scope.admonInfo.admScope = angular.copy(admonInfo.admScope);				
				deleteAdmon(admonInfo);
				$scope.admonInEdition = admonInfo;
			}		
			
			function deleteAdmon(admonInfo) {
				var index = 0;
				for (; index < $scope.roleData.administrations.length; index++) {
					if ($scope.roleData.administrations[index] === admonInfo) {
						break;
					}
				}

				$scope.roleData.administrations.splice(index, 1);
			}			
			function isAddAdmonActionDisable() {
			    
			    return (!$scope.roleData.technicalAssistance && $scope.roleData.administrations.length > 0)
			        || ($scope.roleData.technicalAssistance && $scope.admonInfo.validTo == null)
			        || ($scope.roleData.technicalAssistance
			            && $scope.admonInfo.validFrom != null
			            && $scope.admonInfo.validTo != null
			            && !moment($scope.admonInfo.validTo).isAfter($scope.admonInfo.validFrom))
			        || ($scope.roleData.technicalAssistance && !isCheckedAtLeastOneAdmScope())
			        || $scope.admonInfo.adminId == null
			        || isAdmonAlreadyAdded();
			} 			
			function isCheckedAtLeastOneAdmScope() {
			    var found = false;

			    angular.forEach($scope.admonInfo.admScope, function(scope) {
			        found = found || scope.checked;
			    });
			    
			    return found;
			}              
			function isAdmonAlreadyAdded() {
			    var found = false;

			    angular.forEach($scope.roleData.administrations, function(admonInfo) {
			        found = found || admonInfo.adminId === $scope.admonInfo.adminId;
			    })
			    
			    return found;
			} 
			function cancelAdmonCuencaEdition() {
				$scope.addAdmon($scope.admonInEdition);
				$scope.admonInEdition = null;
			}
			
			
			//*********
			// CCAA_ARU
			//*********
			function clearCcaaInfo() {      
				$scope.ccaaInfo = {};          
			    $scope.ccaaInfo.ccaaId = null;
			    $scope.ccaaInfo.nombre = null;
			}
			function deleteCcaa (ccaaInfo){
			    var index = 0;
			    for (; index < $scope.roleData.ccaas.length; index++) {
			        if ($scope.roleData.ccaas[index] === ccaaInfo) {
			            break;
			        }
			    }

			    $scope.roleData.ccaas.splice(index, 1);
			} 		
			function openCcaaDialog() {

				$mdDialog.show({
					clickOutsideToClose: true,
					controller: "openCcaaDialogController",
					parent: angular.element(document.body),
					templateUrl: "/cc/ccaa-dialog/template",

				})
					.then(
						function(selected) {
							$scope.ccaaInfo.ccaaId = selected.key;
							$scope.ccaaInfo.nombre = selected.value
						}
					);
			}
			function addCcaa (ccaaInfo){
			    if (!$scope.isCcaaAlreadyAdded ( ccaaInfo )){
			        $scope.roleData.ccaas.push ( angular.copy(ccaaInfo ));
			        clearCcaaInfo();
			    }				
			}   
			function isCcaaAlreadyAdded(p_ccaaInfo) {
			    var found = false;

			    angular.forEach($scope.roleData.ccaas, function(ccaaInfo) {
			        found = found || ccaaInfo.ccaaId === p_ccaaInfo.ccaaId;
			    })

			    return found;
			}
			function isAddCcaaActionDisable (){
			    return ( $scope.ccaaInfo.ccaaId == null );
			}  
			
			//*******************************
			//COORDINADOR
			//*******************************
			
			$scope.$watch( function () {
			   // Return the specific object you want to watch
			   return $scope.roleData.dhs[0];
			 }
			 ,function(newValue,oldValue) {
				$scope.reloadCoordinadorDh();			     
			});		
			function reloadCoordinadorDh (){
				if ( $scope.roleData.dhs && $scope.roleData.dhs.length==1 ){
					angular.forEach($scope.dhs, function(value, key) {
						if (value.id === $scope.roleData.dhs[0].dhId) {
							$scope.coordinadordh.selectedDh = value;
						}
					});
				}
				
			}	
			function coordinadorDhChange (){
				$scope.roleData.dh = {};
				$scope.roleData.dhs[0] = {};
				$scope.roleData.dhs[0].dhId = $scope.coordinadordh.selectedDh.id;
				$scope.roleData.dhs[0].nombreDh = $scope.coordinadordh.selectedDh.rbdName;

			}
			function clearCoordinadordh (){		
				$scope.coordinadordh={};
				$scope.coordinadordh.selectedDh={};
				$scope.reloadCoordinadorDh();
			}
			//*******************************
			//CONSULTA
			//*******************************
			function clearDhInfo (){
				$scope.dhInfo = {};
			    $scope.dhInfo.dhId = null;
				$scope.dhInfo.nombreDh = "";
			}
			function deleteDh(dhInfo) {
				let index = 0;
				if (!dhInfo.dhId == '-1') {
					$scope.roleData.allDhs = false;
				}

				for (; index < $scope.roleData.dhs.length; index++) {
					if ($scope.roleData.dhs[index] === dhInfo) {
						break;
					}
				}

				$scope.roleData.dhs.splice(index, 1);
			}
			function openDhDialog() {

				$mdDialog.show({
					clickOutsideToClose: true,
					controller: "openDhDialogController",
					parent: angular.element(document.body),
					templateUrl: "/cc/dh-dialog/template",

				})
					.then(
						function(selected) {
							$scope.dhInfo.dhId = selected.key;
							$scope.dhInfo.nombreDh = selected.value
						}
					);
			}	
			function addDh(dhInfo) {
				if (!$scope.isDhAlreadyAdded(dhInfo)) {

					if (dhInfo.dhId == '-1') {
						$scope.roleData.allDhs = true;
					}


					$scope.roleData.dhs.push(angular.copy(dhInfo));
					clearDhInfo();
				}
			}

			function isDhAlreadyAdded(p_dhInfo) {
				var found = false;

				angular.forEach($scope.roleData.dhs, function(dhInfo) {
					found = found || dhInfo.dhId === p_dhInfo.dhId;
				})

				return found;
			}

			function isAddDhActionDisable() {
				if ($scope.dhInfo.dhId == null) {
					return true;
				}
				return false;
			}			
			
			function validToChange() {
				var today = moment();
				var validTo = $scope.admonInfo.validTo;
				if(validTo < today) {
					$scope.admonInfo.validTo = null;
				}
			}		
			
		}]
	}
});